export enum OrderStylesDoorBuilderTestTextAreaEnum {
  DOOR_NOTES_TA = 'door-notes-ta',
  HARDWARE_NOTES_TA = 'hardware-notes-ta',
}

export enum OrderStylesDoorBuilderTestCheckboxEnum {
  ONE_INCH_DOOR_CHB = 'one-inch-door-chb',
}
